import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';

import './userDisplay.css';

class UserDisplay extends Component {
    get labels() {
        return chainesLocales['UserDisplay'][this.props.lang];
    }

    render() {
        return (
            <div className="row my-3">
                <div className="col-12 font-weight-bold" style={{ fontSize: "1.1rem" }}>{this.labels.identText}</div>
                <div className="col-12">{this.props.user}</div>
            </div>
        );
    }
}

UserDisplay.defaultProps = {
    user: '',
    lang: 'FR'
};

UserDisplay.propTypes = {
    user: PropTypes.string.isRequired,
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS'])
};

export default UserDisplay;